module.exports = __webpack_public_path__ + "img/68.8.TSS.6e2814e1.png";